module.exports = __webpack_public_path__ + "img/nodata.6f826cbd.png";